import React from "react";
import { AutorizacionesCard } from "../../../autorizaciones/UI/AutorizacionesCard";
import { IntegracionComplementoOrdenElementos } from "./IntegracionComplementoOrdenElementos";

export const IntegracionComplementoOrden = () => {

  return (
    <AutorizacionesCard width={"55%"} integracion={true} >
      <IntegracionComplementoOrdenElementos />
    </AutorizacionesCard >
  );
};